// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pill-managing_wrapper__1W9F2","pill":"pill-managing_pill__lOuHJ","pillItem":"pill-managing_pillItem__1IdYX"};